import React from 'react';

function HomePage() {
    window.location.href='/login';
}

export default HomePage;